module.exports = "/images/1ec288a19fbe79243bb8ad9bcc45901d.jpg";